import React from 'react';
import AsignacionExtras from '../../../components/Extras/AsignacionExtras';

const AsignacionesPage = () => {
  return <AsignacionExtras />;
};

export default AsignacionesPage;
